/* see docs/EXTRACTED_COMMENTS.md#c059 */

import { InlineClassPicker, type PickerEntry } from "./InlineClassPicker"
import type { FontOption } from "./types"
import type { API } from "@editorjs/editorjs"

export class FontPickerTool extends InlineClassPicker {
  static title = "Font"

  private fonts: FontOption[]

  constructor({
    api,
    config,
  }: {
    api: API
    config?: { fonts?: FontOption[] }
  }) {
    super({ api })
    this.fonts = config?.fonts ?? []
  }

  protected get pickerTitle(): string {
    return "Font"
  }

  protected get icon(): string {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <text x="12" y="16.5" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif"
        font-size="15" font-weight="600" fill="currentColor">Aa</text>
    </svg>`
  }

  protected get entries(): PickerEntry[] {
    return this.fonts.map(font => ({
      label: font.label,
      className: font.className,
      style: { fontFamily: font.fontFamily },
    }))
  }
}
